module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "#F9FCFF"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "personal"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('personal_center')))]), _vm._v(" "), _c('a', {
    staticClass: "box-button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.$t('sign_out')))])]), _vm._v(" "), _c('modal', {
    model: {
      value: (_vm.modalStatus),
      callback: function($$v) {
        _vm.modalStatus = $$v
      },
      expression: "modalStatus"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l((_vm.tabs), function(item, index) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.to,
        "active-class": "active"
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('router-view')], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0310f3eb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Personal.vue
// module id = 773
// module chunks = 0